import { MapLike } from '../../core'

// DeviceTypes is problematic in that it is an enum (from day 0) and can't be added to by external projects
// Other enum like structures have avoided this (2025 06) since, but still require generics and sleight of hand to make work
// the pattern of OperationType from DynamoDB Streams lws/node_modules/@aws-sdk/client-dynamodb-streams/dist-types/models/models_0.d.ts
// may offer at least an improvement on the enum-like approach.
/*
export const DeviceTypes = {
  VesselSensor: 0x10,           // 16
  ElsysSensor: 0x12,            // 18
  SolenoidController: 0x17,     // 23
  Agritel: 0x1a,                // 26
  GPSMLC: 0x1b,                 // 27
  RadarDistance: 0x1c,          // 28
  TakeFlowMeter: 0x1d,          // 29
  AngelTel: 0x1e,
  GenericSensor: 0x20,          // 32
  EffluentTracker: 0x21,        // 33
  Pump: 0x22,                   // 34
  SoilMoisture: 0x23,           // 35
} as const;

export type DeviceTypes = typeof DeviceTypes[keyof typeof DeviceTypes];

*/
// it seems likely that a direct replacement using the above will cause
// -- a lot of import { DeviceTypes, type DeviceTypes } changes
// changes and probably typecheck errors althugh a file may apparently import two DeviceTypes refrences providedd one is a type and the other isn't

/** the device types supported by the system */
export enum DeviceTypes {
  VesselSensor = 0x10, //16, https://docs.google.com/spreadsheets/d/1tS0bHgITcMuMU0V66kHvH7GzOEj_Yvrk/edit#gid=779257245
  ElsysSensor = 0x12, // supposed to be 0x12, //18
  SolenoidController = 0x17, //23
  Agritel = 0x1a, //26
  GPSMLC = 0x1b, //27
  RadarDistance = 0x1c, //28
  TakeFlowMeter = 0x1d, //29
  Pump = 0x22, //34
  GenericSensor = 0x20, //32
  SoilMoisture = 0x23, //35
  AngelTel = 0x1e,
  EffluentTracker = 0x21, //33
  IsolationValve = 0x24, //36
  SenseTel = 0x25, //0x37
}

export type DeviceTypeResponse = { deviceTypeName: string; deviceType: DeviceTypes }

export const resolveDeviceType = (prefixedString: string | undefined) => {
  let deviceTypeRes: DeviceTypeResponse | undefined = undefined
  if (prefixedString) {
    const prefix: number = parseInt(prefixedString.substring(0, 2), 16)

    const res = DeviceTypes[prefix]
    const toMap = Object.fromEntries(Object.entries(DeviceTypes).filter(([k, v]) => typeof v === 'number')) as MapLike<DeviceTypes>
    const resOfRes = toMap[res]
    if (res && resOfRes) {
      deviceTypeRes = {
        deviceTypeName: res,
        deviceType: resOfRes,
      }
    }
  }

  return deviceTypeRes
}
